// IIFE as we want to polyfill ASAP

const enhanceTemplateTag = node => {
	const content = node.childNodes;
	const fragment = document.createDocumentFragment();
	while(content[0]) {
		fragment.appendChild(content[0]);
	}
	node.content = fragment;
};


(() => {
	if ('content' in document.createElement('template')) {
		return false;
	}
	
	const templates = [...document.getElementsByTagName('template')];

	templates.forEach(enhanceTemplateTag);

	const observer = new MutationObserver(mutations => {
		mutations.forEach(mutation => {
			const addedNodes = [...mutation.addedNodes].filter(node => node.nodeType === 1);
			addedNodes.forEach(newNode => {
				const newTemplates = [...newNode.querySelectorAll('template')];
				newTemplates.forEach(enhanceTemplateTag);
			});
		});
	});

	const observerConfig = { childList: true, subtree: true };

	observer.observe(document, observerConfig);
})();
